const PaymentType = {
  schema: {
    type: 'object',
    properties: {
      name: {
        type: 'string',
        minLength: 3,
        maxLength: 100,
        customErrors: '',
      },
    },
    required: ['name'],
  },
  uischema: {
    type: 'Group',
    label: 'Cadastro de Tipo de pagamento',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            label: 'Nome',
            scope: '#/properties/name',
          },
        ],
      },
    ],
  },
  updateUischema: {
    type: 'Group',
    label: 'Tipo de pagamento',
    elements: [
      {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            label: 'Nome',
            scope: '#/properties/name',
          },
        ],
      },
    ],
  },
  tableSchema: [{ id: 'name', label: 'Nome', minWidth: 100, align: 'center' }],
  listSchema: [
    { id: 'name', label: 'Nome', minWidth: 100, align: 'center' },
    {
      id: 'expenseType',
      label: 'Tipo de Despesa',
      minWidth: 100,
      align: 'center',
    },
  ],
  actions: {
    create: 'PaymentTypeController@create',
    update: 'PaymentTypeController@patchUpdate',
    findById: 'PaymentTypeController@findById',
    getAll: 'PaymentTypeController@getAll',
    delete: 'PaymentTypeController@delete',
  },
};

export default PaymentType;
